<!-- 下发车辆预存款给云停车场接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KM43Y46",
                "parkingCode": "20160723162730110",
                "prestoreAmount": "20"
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台向某个车辆预置预存款，用于后续车辆自动扣费",
                t_url: this.commonUrls.test+"setPrestoreForCParkFirstPayBeforeLeave",
                p_url: this.commonUrls.prod+"setPrestoreForCParkFirstPayBeforeLeave",
                flow: '/static/img/unconsciousPayBeforeLeaving.svg',
                precondition: {
                  preData: "对接接口-",
                  link:  "云停车场通知第三方缴费(先扣费后离场)",
                  url: "reducePrestore",
                  endData: "，用于接收预存款离场时的费用信息"
                },
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'prestoreAmount', info2: '是', info3: 'Decimal', info4: '预存款金额' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/setPrestoreForCParkFirstPayBeforeLeave.vue